import styled from 'styled-components';
import { theme, cssVar } from './theme';

// 공통으로 사용할 수 있는 스타일 컴포넌트들

// 컨테이너 (중앙 정렬, 최대 너비)
export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

// 카드 스타일
export const Card = styled.div`
  background: ${cssVar('color-bg-white', theme.colors.white)};
  border-radius: var(--erp-radius-panel, ${theme.borderRadius.md});
  padding: ${theme.spacing.lg};
  border: 1px solid ${cssVar('color-border', theme.colors.border)};
  box-shadow: var(--erp-panel-shadow, ${theme.shadows.card});
`;

// 카드 내부 제목
export const CardTitle = styled.h2`
  margin-bottom: ${theme.spacing.sm};
  color: ${cssVar('color-text', theme.colors.text.primary)};
  font-size: ${theme.typography.fontSize.lg};
  font-weight: 600;
`;

// 상태 카드
export const StatusCard = styled.div`
  background: ${cssVar('color-bg-light', theme.colors.background.light)};
  border: 1px solid ${cssVar('color-border', theme.colors.border)};
  border-radius: ${theme.borderRadius.sm};
  padding: ${theme.spacing.md};
  margin-top: ${theme.spacing.sm};
`;

// 상태 카드 제목
export const StatusCardTitle = styled.h3`
  margin-bottom: ${theme.spacing.sm};
  color: ${cssVar('color-text-secondary', theme.colors.text.secondary)};
`;

// 상태 텍스트 (동적 색상)
// $ prefix를 사용하여 DOM으로 전달되지 않도록 함
export const StatusText = styled.p`
  font-weight: bold;
  font-size: ${theme.typography.fontSize.lg};
  margin-bottom: ${theme.spacing.xs};
  color: ${props => {
    if (props.$status === 'up') return theme.colors.status.success;
    if (props.$status === 'down') return theme.colors.status.error;
    return cssVar('color-text-tertiary', theme.colors.text.tertiary);
  }};
`;

// 메시지 텍스트
export const MessageText = styled.p`
  color: ${cssVar('color-text-tertiary', theme.colors.text.tertiary)};
  font-size: ${theme.typography.fontSize.sm};
`;

// 헤더 스타일 (TGS — 화이트 헤더)
export const Header = styled.header`
  background-color: ${cssVar('color-bg-white', theme.colors.white)};
  color: ${cssVar('color-text', theme.colors.text.primary)};
  border-bottom: 1px solid ${cssVar('color-border', theme.colors.border)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacing.md};
  flex-shrink: 0;
  min-height: ${theme.layout.headerHeight};
  padding: 0 ${theme.spacing.md};
`;

// 헤더 왼쪽 영역
export const HeaderLeft = styled.div`
  width: ${theme.layout.sidebarWidth};
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  flex-shrink: 0;
`;

// 헤더 가운데 영역 (Top 메뉴)
export const HeaderCenter = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 0;
`;

// 헤더 우측 영역
export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  white-space: nowrap;
`;

// 사용자 정보 표시
export const UserInfo = styled.span`
  font-size: ${theme.typography.fontSize.sm};
  color: ${cssVar('color-text-secondary', theme.colors.text.secondary)};
`;

// 로그아웃 버튼
export const LogoutButton = styled.button`
  background: none;
  color: ${cssVar('color-text-secondary', theme.colors.text.secondary)};
  border: none;
  border-radius: ${theme.borderRadius.sm};
  padding: ${theme.spacing.xxs} ${theme.spacing.xs};
  font-size: ${theme.typography.fontSize.sm};
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: ${cssVar('color-primary', theme.colors.primary)};
  }
`;

// 푸터 스타일



export const Footer = styled.footer`
  background-color: ${cssVar('color-bg-light', theme.colors.background.light)};
  color: ${cssVar('color-text-tertiary', theme.colors.text.tertiary)};
  padding: ${theme.spacing.xxs} ${theme.spacing.md};
  text-align: center;
  flex-shrink: 0;
  border-top: 1px solid ${cssVar('color-border', theme.colors.border)};
  font-size: ${theme.typography.fontSize.xs};

  p {
    margin: 0;
  }
`;

// 메인 콘텐츠 영역
export const MainContent = styled.main`
  flex: 1;
  padding: ${theme.spacing.lg};
  background-color: ${theme.colors.secondary};
`;

// 레이아웃 컨테이너
export const LayoutContainer = styled.div`
  height: 100vh; // 브라우저 창 높이에 딱 맞춤
  display: flex;
  flex-direction: column;
  overflow: hidden; // 스크롤 방지
`;

// 대시보드 레이아웃 (Left, Content 구조 - Top 메뉴는 Header에 통합됨)
export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1; // Header와 Footer를 제외한 남은 공간을 모두 차지
  overflow: hidden;
  min-height: 0; // flex item이 overflow를 올바르게 처리하도록
`;

// Top 메뉴와 Content를 감싸는 영역
export const DashboardBody = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

// Tab 영역을 감싸는 컨테이너
export const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

// ==================== TopMenu 스타일 ====================

// Top 메뉴 컨테이너 (Header 안에 통합)
export const TopMenuContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  height: 100%;
`;

// Top 메뉴 아이템
export const TopMenuItem = styled.button`
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  background-color: transparent;
  color: ${props => (props.$active ? cssVar('color-primary', theme.colors.primary) : cssVar('color-text-secondary', theme.colors.text.secondary))};
  border: none;
  border-bottom: 2px solid ${props => (props.$active ? cssVar('color-primary', theme.colors.primary) : 'transparent')};
  cursor: pointer;
  font-size: ${theme.typography.fontSize.md};
  transition: all 0.2s;
  white-space: nowrap;
  font-weight: ${props => (props.$active ? '600' : '400')};

  &:hover {
    color: ${cssVar('color-primary', theme.colors.primary)};
  }
`;

// ==================== Sidebar 스타일 ====================

// 사이드바 토글 버튼
export const SidebarToggleButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  padding: 0;
  flex-shrink: 0;
  font-size: 16px;
  line-height: 1;
  color: ${cssVar('color-text', theme.colors.text.primary)};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  border-radius: ${theme.borderRadius.sm};

  &:hover {
    background-color: ${cssVar('color-primary-light', theme.colors.primaryLight)};
    color: ${cssVar('color-primary', theme.colors.primary)};
  }

  &:active {
    transform: scale(0.95);
  }
`;

// 사이드바 컨테이너
export const SidebarContainer = styled.div`
  width: ${(p) => (p.$collapsed ? 'var(--erp-sidebar-collapsed-width, 56px)' : 'var(--erp-sidebar-width, 240px)')};
  background-color: ${cssVar('color-bg-sidebar', theme.colors.background.sidebar)};
  border-right: 1px solid ${cssVar('color-border', theme.colors.border)};
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: width 0.25s ease;
  flex-shrink: 0;
`;

/** 모듈 레일 — MenuList와 동일 스펙(상단 6 / gap 6 / 행 32) */
export const SidebarRail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--erp-form-field-gap, ${theme.components?.form?.fieldGap || '6px'});
  padding: var(--erp-form-field-gap, ${theme.components?.form?.fieldGap || '6px'}) 0 0;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

/** 펼침 MenuItemHeader(height 32)와 동일 */
export const SidebarRailButton = styled.button`
  width: var(--erp-sidebar-item-height, 32px);
  height: var(--erp-sidebar-item-height, 32px);
  min-height: var(--erp-sidebar-item-height, 32px);
  box-sizing: border-box;
  padding: 0;
  border-radius: var(--erp-sidebar-item-radius, ${theme.borderRadius.md});
  border: 1px solid ${(p) => (p.$active ? cssVar('color-primary', theme.colors.primary) : 'transparent')};
  background: ${(p) => (p.$active ? cssVar('color-primary-light', theme.colors.primaryLight) : 'transparent')};
  color: ${(p) => (p.$active ? cssVar('color-primary', theme.colors.primary) : cssVar('color-text-secondary', theme.colors.text.secondary))};
  font-size: ${theme.typography.fontSize.sm};
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:hover {
    background: ${cssVar('color-primary-light', theme.colors.primaryLight)};
    color: ${cssVar('color-primary', theme.colors.primary)};
  }
`;

export const SidebarLogoutButton = styled.button`
  margin-top: 0;
  width: 100%;
  padding: 6px 8px;
  border: 1px solid ${cssVar('color-border', theme.colors.border)};
  border-radius: ${theme.borderRadius.sm};
  background: ${cssVar('color-bg-white', theme.colors.white)};
  color: ${cssVar('color-text-secondary', theme.colors.text.secondary)};
  font-size: ${theme.typography.fontSize.xs};
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    border-color: ${cssVar('color-primary', theme.colors.primary)};
    color: ${cssVar('color-primary', theme.colors.primary)};
  }
`;

// 사이드바 브랜드 영역
export const SidebarBrand = styled.div`
  padding: ${theme.spacing.md} ${theme.spacing.sm};
  border-bottom: 1px solid ${cssVar('color-border', theme.colors.border)};
`;

export const SidebarBrandTitle = styled.div`
  font-size: ${theme.typography.fontSize.md};
  font-weight: 700;
  color: ${cssVar('color-text', theme.colors.text.primary)};
  line-height: 1.3;
`;

export const SidebarBrandSub = styled.div`
  font-size: ${theme.typography.fontSize.xxs};
  color: ${cssVar('color-text-tertiary', theme.colors.text.tertiary)};
  margin-top: 2px;
`;

// 사이드바 검색
export const SidebarSearchWrap = styled.div`
  padding: 0 ${theme.spacing.sm};
  border-bottom: 1px solid ${cssVar('color-border', theme.colors.border)};
  display: flex;
  align-items: center;
  justify-content: ${(p) => (p.$collapsed ? 'center' : 'flex-start')};
  gap: 6px;
  height: 48px;
  min-height: 48px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

export const SidebarLogoArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 ${(p) => (p.$collapsed ? '6px' : '12px')};
  border-bottom: 1px solid ${cssVar('color-border', theme.colors.border)};
  flex-shrink: 0;
  height: ${theme.layout.topChromeHeight};
  min-height: ${theme.layout.topChromeHeight};
  box-sizing: border-box;
  /* $dark: 기관 CI 강제 다크 플레이트 · $colorModeDark: 앱 다크모드 시 셸과 동일 톤 */
  background: ${(p) => {
    if (p.$dark) return `var(--erp-color-sidebar-dark, ${theme.colors.sidebarDark})`;
    if (p.$colorModeDark) return cssVar('color-bg-sidebar', theme.colors.background.sidebar);
    return 'transparent';
  }};
`;

export const SidebarLogoMark = styled.div`
  width: 24px;
  height: 24px;
  border-radius: ${theme.borderRadius.sm};
  background: ${cssVar('color-primary', theme.colors.primary)};
  color: var(--erp-color-on-accent, #FFFFFF);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: -0.02em;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const SidebarLogoText = styled.div`
  min-width: 0;
  line-height: 1.15;
`;

export const SidebarLogoTitle = styled.div`
  font-size: ${theme.typography.fontSize.sm};
  font-weight: 700;
  color: ${cssVar('color-text', theme.colors.text.primary)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SidebarLogoSub = styled.div`
  font-size: ${theme.typography.fontSize.xxs};
  color: ${cssVar('color-text-tertiary', theme.colors.text.tertiary)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SidebarRailTop = styled.div`
  padding: 8px 0 4px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
`;

export const SidebarHeader = styled.div`
  padding: ${(p) => (p.$collapsed ? '0' : '0 4px')};
  border-bottom: 1px solid ${cssVar('color-border', theme.colors.border)};
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: ${(p) => (p.$collapsed ? 'center' : 'flex-start')};
  height: 36px;
  min-height: 36px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

export const SidebarLogoutIconButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  border-radius: ${theme.borderRadius.md};
  background: ${(p) => (p.$active ? cssVar('color-primary-light', theme.colors.primaryLight) : 'transparent')};
  color: ${(p) =>
    p.$active ? cssVar('color-primary', theme.colors.primary) : cssVar('color-text-tertiary', theme.colors.text.tertiary)};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 16px;
  line-height: 1;

  &:hover {
    background: ${(p) =>
      p.$danger
        ? theme.colors.status.dangerSoft
        : cssVar('color-primary-light', theme.colors.primaryLight)};
    color: ${(p) =>
      p.$danger
        ? theme.colors.status.dangerText
        : cssVar('color-primary', theme.colors.primary)};
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const FavoriteStarButton = styled.button`
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  margin-left: 4px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${(p) => (p.$active ? theme.colors.yellow : cssVar('color-text-tertiary', theme.colors.text.tertiary))};
  font-size: 14px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.borderRadius.sm};

  &:hover {
    color: ${theme.colors.yellow};
    background: ${cssVar('color-bg-light', theme.colors.background.light)};
  }
`;

export const MenuTypeIconWrap = styled.span`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-right: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* 등록·조회·출력 동일 primary — 선택 행(파란 배경)에서는 아이콘이 묻힘 */
  color: ${cssVar('color-primary', theme.colors.primary)};

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const SidebarFilterButton = styled.button`
  flex: 1 1 0;
  min-width: 0;
  padding: 3px 3px;
  background-color: ${(p) => (p.$active ? cssVar('color-primary-light', theme.colors.primaryLight) : cssVar('color-bg-white', theme.colors.white))};
  border: 1px solid ${(p) => (p.$active ? cssVar('color-primary', theme.colors.primary) : cssVar('color-border', theme.colors.border))};
  border-radius: ${theme.borderRadius.sm};
  cursor: pointer;
  font-size: 10px;
  color: ${(p) => (p.$active ? cssVar('color-primary', theme.colors.primary) : cssVar('color-text-secondary', theme.colors.text.secondary))};
  font-weight: ${(p) => (p.$active ? 600 : 400)};
  transition: all 0.2s;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    border-color: ${cssVar('color-primary', theme.colors.primary)};
    color: ${cssVar('color-primary', theme.colors.primary)};
  }
`;

export const SidebarButton = styled.button`
  flex: 1 1 0;
  min-width: 0;
  padding: 3px 3px;
  background-color: ${cssVar('color-bg-white', theme.colors.white)};
  border: 1px solid ${cssVar('color-border', theme.colors.border)};
  border-radius: ${theme.borderRadius.sm};
  cursor: pointer;
  font-size: 10px;
  color: ${cssVar('color-text-secondary', theme.colors.text.secondary)};
  transition: all 0.2s;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    border-color: ${cssVar('color-primary', theme.colors.primary)};
    color: ${cssVar('color-primary', theme.colors.primary)};
  }
`;

/** 사이드바 상단 — 다크/라이트 아이콘 (☾/☀) */
export const SidebarThemeIconButton = styled.button`
  flex: 0 0 28px;
  width: 28px;
  min-width: 28px;
  height: 26px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${(p) => (p.$active ? cssVar('color-primary-light', theme.colors.primaryLight) : cssVar('color-bg-white', theme.colors.white))};
  border: 1px solid ${(p) => (p.$active ? cssVar('color-primary', theme.colors.primary) : cssVar('color-border', theme.colors.border))};
  border-radius: ${theme.borderRadius.sm};
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  color: ${(p) => (p.$active ? cssVar('color-primary', theme.colors.primary) : cssVar('color-text-secondary', theme.colors.text.secondary))};

  &:hover:not(:disabled) {
    border-color: ${cssVar('color-primary', theme.colors.primary)};
    color: ${cssVar('color-primary', theme.colors.primary)};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const SidebarSearchInput = styled.input`
  width: 100%;
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  border: 1px solid ${cssVar('color-border', theme.colors.border)};
  border-radius: ${theme.borderRadius.pill};
  font-size: ${theme.typography.fontSize.sm};
  background: ${cssVar('color-bg-white', theme.colors.white)};
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${cssVar('color-primary', theme.colors.primary)};
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
  }

  &::placeholder {
    color: ${cssVar('color-text-tertiary', theme.colors.text.tertiary)};
  }
`;

// 사이드바 하단 사용자
export const SidebarUserFooter = styled.div`
  padding: ${(p) => (p.$collapsed ? '8px 6px' : theme.spacing.sm)};
  border-top: 1px solid ${cssVar('color-border', theme.colors.border)};
  display: flex;
  flex-direction: ${(p) => (p.$collapsed ? 'column' : 'column')};
  align-items: ${(p) => (p.$collapsed ? 'center' : 'stretch')};
  gap: ${(p) => (p.$collapsed ? '6px' : '8px')};
  background: ${cssVar('color-bg-white', theme.colors.white)};
  flex-shrink: 0;
`;

export const SidebarUserRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  min-width: 0;
`;

export const SidebarUserAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${cssVar('color-primary-light', theme.colors.primaryLight)};
  color: ${cssVar('color-primary', theme.colors.primary)};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${theme.typography.fontSize.sm};
  font-weight: 600;
  flex-shrink: 0;
`;

export const SidebarUserInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SidebarUserName = styled.div`
  font-size: ${theme.typography.fontSize.sm};
  font-weight: 600;
  color: ${cssVar('color-text', theme.colors.text.primary)};
`;

export const SidebarUserRole = styled.div`
  font-size: ${theme.typography.fontSize.xxs};
  color: ${cssVar('color-text-tertiary', theme.colors.text.tertiary)};
`;



// 사이드바 버튼
export const SidebarFavoriteButton = styled.button`
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  margin-left: 4px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${(p) => (p.$active ? theme.colors.yellow : cssVar('color-text-tertiary', theme.colors.text.tertiary))};
  font-size: 14px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.borderRadius.sm};

  &:hover {
    color: ${theme.colors.yellow};
    background: rgba(245, 158, 11, 0.12);
  }
`;

export const SidebarModeButton = styled.button`
  flex: 1;
  min-width: 0;
  padding: 6px 8px;
  background-color: ${(p) => (p.$active ? cssVar('color-primary-light', theme.colors.primaryLight) : cssVar('color-bg-white', theme.colors.white))};
  border: 1px solid ${(p) => (p.$active ? cssVar('color-primary', theme.colors.primary) : cssVar('color-border', theme.colors.border))};
  border-radius: ${theme.borderRadius.sm};
  cursor: pointer;
  font-size: ${theme.typography.fontSize.xs};
  color: ${(p) => (p.$active ? cssVar('color-primary', theme.colors.primary) : cssVar('color-text-secondary', theme.colors.text.secondary))};
  font-weight: ${(p) => (p.$active ? 600 : 500)};
  transition: all 0.2s;
  line-height: 1.2;
  white-space: nowrap;

  &:hover {
    border-color: ${cssVar('color-primary', theme.colors.primary)};
    color: ${cssVar('color-primary', theme.colors.primary)};
  }
`;

// 메뉴 리스트 (overflow 시 이 영역만 세로 스크롤)
/** 접힘 SidebarRail과 동일 — 테마영역~첫 모듈 6px, 모듈 간격 6px */
export const MenuList = styled.ul`
  list-style: none;
  padding: var(--erp-form-field-gap, ${theme.components?.form?.fieldGap || '6px'}) 0 0;
  margin: 0;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--erp-form-field-gap, ${theme.components?.form?.fieldGap || '6px'});
`;

// 사이드바 메뉴 아이템
export const SidebarMenuItem = styled.li`
  user-select: none;
`;

// 메뉴 아이템 헤더
// 메뉴 아이템 헤더 — 접힘 SidebarRailButton과 동일 행고(32) / 모듈 간격은 MenuList gap
export const MenuItemHeader = styled.div`
  padding: ${(props) => {
    const level = props.$level || 0;
    const leftPadding = `${8 + level * 12}px`;
    return `0 10px 0 ${leftPadding}`;
  }};
  margin: 0 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${cssVar('color-text-secondary', theme.colors.text.secondary)};
  font-size: ${theme.typography.fontSize.sm};
  line-height: 1.3;
  transition: all 0.2s;
  height: var(--erp-sidebar-item-height, 32px);
  min-height: var(--erp-sidebar-item-height, 32px);
  max-height: var(--erp-sidebar-item-height, 32px);
  box-sizing: border-box;
  border-radius: var(--erp-sidebar-item-radius, ${theme.borderRadius.md});
  border: 1px solid transparent;

  &:hover {
    background-color: ${cssVar('color-primary-light', theme.colors.primaryLight)};
    color: ${cssVar('color-primary', theme.colors.primary)};
  }

  ${(props) =>
    props.$active &&
    `
    background-color: ${cssVar('color-primary', theme.colors.primary)};
    color: var(--erp-color-on-accent, #FFFFFF);
    font-weight: 600;
    box-shadow: ${theme.shadows.sm};
  `}
`;

// 메뉴 아이템 라벨
export const MenuItemLabel = styled.span`
  flex: 1;
  min-width: 0;
  font-weight: ${props => props.$fontWeight ? props.$fontWeight : 'normal'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// 확장 아이콘
export const ExpandIcon = styled.span`
  font-size: 0.65rem; // 폰트 크기 축소
  transition: transform 0.2s;
  transform: ${props => props.$expanded ? 'rotate(90deg)' : 'rotate(0deg)'};
  margin-left: ${theme.spacing.xs};
`;

// 서브 메뉴 리스트
export const SubMenuList = styled.ul`
  list-style: none;
  padding: ${(props) => (props.$expanded ? '2px 0 0' : '0')};
  margin: 0;
  background-color: transparent;
  display: ${(props) => (props.$expanded ? 'flex' : 'none')};
  flex-direction: column;
  /* 상위↔첫 하위·하위끼리 동일 2px */
  gap: 2px;
`;

// 메뉴 그룹 라벨
export const MenuGroupLabel = styled.div`
  padding: ${theme.spacing.sm} ${theme.spacing.md} ${theme.spacing.xxs};
  font-size: ${theme.typography.fontSize.xxs};
  font-weight: 600;
  color: ${cssVar('color-text-tertiary', theme.colors.text.tertiary)};
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;
// 사이드바 빈 상태 메시지
export const SidebarEmptyMessage = styled.div`
  padding: ${theme.spacing.lg};
  text-align: center;
  color: ${cssVar('color-text-secondary', theme.colors.text.secondary)};
`;

// ==================== TabArea 스타일 ====================

// Tab 영역 컨테이너
export const TabAreaContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

// Tab 리스트
export const TabList = styled.div`
  display: flex;
  background-color: ${cssVar('color-bg-white', theme.colors.white)};
  border-bottom: 1px solid ${cssVar('color-border', theme.colors.border)};
  overflow-x: auto;
  overflow-y: hidden;
  min-height: ${theme.layout.topChromeHeight};
  height: ${theme.layout.topChromeHeight};
  align-items: center;
  padding: 0 ${theme.spacing.xs};

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

// Tab 버튼
export const Tab = styled.button`
  padding: 0.4rem 1rem;
  background-color: ${props => (props.$active ? cssVar('color-primary-light', theme.colors.primaryLight) : 'transparent')};
  border: none;
  border-radius: ${theme.borderRadius.sm} ${theme.borderRadius.sm} 0 0;
  border-bottom: ${props => (props.$active ? `2px solid ${cssVar('color-primary', theme.colors.primary)}` : '2px solid transparent')};
  cursor: pointer;
  font-size: ${theme.typography.fontSize.sm};
  color: ${props => (props.$active ? cssVar('color-primary', theme.colors.primary) : cssVar('color-text-secondary', theme.colors.text.secondary))};
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  transition: all 0.2s;
  font-weight: ${props => (props.$active ? '600' : '400')};

  &:hover {
    color: ${cssVar('color-primary', theme.colors.primary)};
    background-color: ${cssVar('color-primary-light', theme.colors.primaryLight)};
  }
`;

// Tab 라벨
export const TabLabel = styled.span`
  flex: 1;
  font-size: ${theme.typography.fontSize.sm};
`;

// Tab 닫기 버튼
export const TabCloseButton = styled.span`
  padding: 2px 4px;
  border-radius: 2px;
  font-size: ${theme.typography.fontSize.xs};
  
  &:hover {
    background-color: ${cssVar('color-border', theme.colors.border)};
  }
`;

// Tab 콘텐츠 영역
export const TabContent = styled.div`
  flex: 1;
  overflow: hidden;
  background-color: ${cssVar('color-bg-page', theme.colors.background.page)};
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

// 빈 상태 표시
export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${cssVar('color-text-tertiary', theme.colors.text.tertiary)};
  font-size: ${theme.typography.fontSize.lg};
`;

// ==================== CompactTabArea 스타일 (라벨형 Tab* 는 변경하지 않음) ====================

export const CompactTabOverlay = styled.div`
  display: none;
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 30;
  background-color: ${cssVar('color-bg-white', theme.colors.white)};
  border-bottom: 1px solid ${cssVar('color-border', theme.colors.border)};
  box-shadow: ${theme.shadows.md};
  overflow-x: auto;
  overflow-y: hidden;
  min-height: ${theme.layout.topChromeHeight};
  align-items: center;
  padding: 0 ${theme.spacing.xs};

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

export const CompactTabBar = styled.div`
  position: relative;
  flex-shrink: 0;
  z-index: 20;
  min-height: ${theme.layout.topChromeHeight};
  height: ${theme.layout.topChromeHeight};
  background-color: ${cssVar('color-bg-white', theme.colors.white)};
  border-bottom: 1px solid ${cssVar('color-border', theme.colors.border)};

  &:hover ${CompactTabOverlay},
  &:focus-within ${CompactTabOverlay} {
    display: flex;
  }
`;

export const CompactTabPath = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 ${theme.spacing.sm};
  font-size: ${theme.typography.fontSize.sm};
  color: ${cssVar('color-text-secondary', theme.colors.text.secondary)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
`;

export const CompactTab = styled.button`
  padding: 0.4rem 1rem;
  background-color: ${(props) =>
    props.$active
      ? cssVar('color-tab-hover-active', theme.colors.tabHoverActive)
      : 'transparent'};
  border: none;
  border-radius: ${theme.borderRadius.sm};
  cursor: pointer;
  font-size: ${theme.typography.fontSize.sm};
  color: ${(props) =>
    props.$active
      ? cssVar('color-primary', theme.colors.primary)
      : cssVar('color-text-secondary', theme.colors.text.secondary)};
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  transition: all 0.2s;
  font-weight: ${(props) => (props.$active ? '600' : '400')};

  &:hover {
    color: ${cssVar('color-primary', theme.colors.primary)};
    background-color: ${cssVar('color-tab-hover-active', theme.colors.tabHoverActive)};
  }
`;

// ==================== Page 스타일 ====================
export const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: var(--erp-page-padding, ${theme.spacing.sm});
  gap: var(--erp-content-gap, 0px);
  background-color: ${cssVar('color-bg-page', theme.colors.background.page)};
  overflow: hidden;
  min-height: 0;
`;

// 페이지 제목
export const PageTitle = styled.h1`
  font-size: ${theme.typography.fontSize.xxl};
  color: ${cssVar('color-text', theme.colors.text.primary)};
  font-weight: 700;
  margin-bottom: ${theme.spacing.sm};
`;

// 페이지 헤더 (브레드크럼 + 타이틀)
export const PageHeader = styled.div`
  margin-bottom: ${theme.spacing.sm};
`;

export const Breadcrumb = styled.nav`
  display: flex;
  align-items: center;
  gap: var(--erp-form-field-gap, ${theme.components?.form?.fieldGap || '6px'});
  font-size: ${theme.typography.fontSize.xs};
  color: ${cssVar('color-text-tertiary', theme.colors.text.tertiary)};
  margin-bottom: ${theme.spacing.xxs};

  span.separator {
    color: ${cssVar('color-border', theme.colors.border)};
  }

  span.current {
    color: ${cssVar('color-text-secondary', theme.colors.text.secondary)};
  }
`;

// 액션 버튼 컨테이너 (기본 버튼 좌측 / 화면전용 버튼 우측)
export const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(p) => (p.$hasExtra ? 'space-between' : 'flex-start')};
  gap: ${theme.spacing.xxs};
  margin-bottom: ${theme.spacing.xs};
  padding: ${theme.spacing.xxs} ${theme.spacing.xs};
  background-color: ${cssVar('color-bg-white', theme.colors.white)};
  border-radius: var(--erp-radius-md, ${theme.borderRadius.md});
  border: 1px solid ${cssVar('color-border', theme.colors.border)};
  box-shadow: var(--erp-toolbar-shadow, none);
`;

export const ActionButtonCluster = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xxs};
  flex-wrap: wrap;
`;

// 액션 버튼 — density는 theme.components.actionButton / CSS 변수 (--erp-btn-*)
export const ActionButton = styled.button`
  padding: var(--erp-btn-padding-y, ${theme.components?.actionButton?.paddingY || '3px'})
    var(--erp-btn-padding-x, ${theme.components?.actionButton?.paddingX || '8px'});
  min-height: var(--erp-btn-min-height, ${theme.components?.actionButton?.minHeight || '26px'});
  line-height: 1.25;
  border: 1px solid ${props => {
    if (props.$variant === 'primary' || props.$variant === 'success') {
      return `var(--erp-color-primary, ${cssVar('color-primary', theme.colors.primary)})`;
    }
    if (props.$variant === 'danger') {
      return `var(--erp-color-status-danger-text, ${theme.colors.status.dangerText})`;
    }
    return `var(--erp-color-border, ${cssVar('color-border', theme.colors.border)})`;
  }};
  border-radius: var(--erp-radius-sm, ${theme.borderRadius.sm});
  background-color: ${props => {
    if (props.$variant === 'primary' || props.$variant === 'success') {
      return `var(--erp-color-primary, ${cssVar('color-primary', theme.colors.primary)})`;
    }
    if (props.$variant === 'danger') {
      return `var(--erp-color-status-danger-soft, ${theme.colors.status.dangerSoft})`;
    }
    return `var(--erp-color-bg-white, ${cssVar('color-bg-white', theme.colors.white)})`;
  }};
  color: ${props => {
    if (props.$variant === 'primary' || props.$variant === 'success') {
      return `var(--erp-color-on-accent, #FFFFFF)`;
    }
    if (props.$variant === 'danger') {
      return `var(--erp-color-status-danger-text, ${theme.colors.status.dangerText})`;
    }
    return `var(--erp-color-text, ${cssVar('color-text', theme.colors.text.primary)})`;
  }};
  font-size: var(--erp-btn-font-size, ${theme.typography.fontSize.sm});
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: var(--erp-btn-gap, ${theme.components?.actionButton?.gap || '0.25rem'});

  &:hover:not(:disabled) {
    opacity: 0.9;
    box-shadow: ${theme.shadows.sm};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

// 필터 레이블
export const FormLabel = styled.label`
  font-size: ${theme.typography.fontSize.xs};
  color: ${cssVar('color-text-secondary', theme.colors.text.secondary)};
  font-weight: 500;
  white-space: nowrap;
`;

// 필터 입력 필드
export const FormInput = styled.input`
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  border: 1px solid ${cssVar('color-border', theme.colors.border)};
  border-radius: ${theme.borderRadius.sm};
  font-size: ${theme.typography.fontSize.sm};
  width: 180px;
  background: ${cssVar('color-bg-white', theme.colors.white)};

  &:focus {
    outline: none;
    border-color: ${cssVar('color-primary', theme.colors.primary)};
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
  }
`;

// 필터 셀렉트
export const FormSelect = styled.select`
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  border: 1px solid ${cssVar('color-border', theme.colors.border)};
  border-radius: ${theme.borderRadius.sm};
  font-size: ${theme.typography.fontSize.sm};
  width: 130px;
  background-color: ${cssVar('color-bg-white', theme.colors.white)};
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${cssVar('color-primary', theme.colors.primary)};
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
  }
`;

// 그리드 컨테이너
export const GridWrapper = styled.div`
  flex: 1;
  background-color: ${cssVar('color-bg-white', theme.colors.white)};
  border-radius: ${theme.borderRadius.sm};
  box-shadow: ${theme.shadows.sm};
  padding: ${theme.spacing.sm};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0; /* flex item이 overflow를 올바르게 처리하도록 */
  height: 100%; /* 부모의 높이를 차지 */
`;


// 두 그리드 레이아웃용 스타일 컴포넌트 (마스터-디테일 구조)
/**
 * 마스터 그리드 영역 컨테이너
 * 
 * 상단에 위치하는 마스터 그리드를 위한 컨테이너입니다.
 * - 화면의 50% 높이를 차지 (flex: 0 0 50%)
 * - 하단 마진 10px
 * - flexbox 레이아웃으로 내부 컨텐츠를 세로로 배치
 * 
 * 사용 예시:
 * ```javascript
 * <MasterGridContainer>
 *   <SearchArea ... />
 *   <ActionButtonGroup ... />
 *   <StandardGrid ... />
 * </MasterGridContainer>
 * ```
 */
export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 50%;
  min-height: 0;
  margin-bottom: 10px;
`;

/**
 * 좌우 분할 레이아웃 컨테이너
 * 
 * 왼쪽과 오른쪽 영역을 나누는 컨테이너입니다.
 * - display: flex
 * - flex-direction: row (가로 배치)
 * - gap: 간격 설정
 * 
 * 사용 예시:
 * ```javascript
 * <SplitLayoutContainer>
 *   <LeftArea>왼쪽 내용</LeftArea>
 *   <RightArea>오른쪽 내용</RightArea>
 * </SplitLayoutContainer>
 * ```
 */
export const SplitLayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing.md};
  height: 100%;
  overflow: hidden;
  min-height: 0;
`;

/**
 * 좌우 분할 레이아웃 - 왼쪽 영역
 * 
 * 기본적으로 50% 너비를 차지하지만, flex 속성으로 조정 가능합니다.
 */
export const LeftArea = styled.div`
  flex: 0 0 50%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`;

/**
 * 좌우 분할 레이아웃 - 오른쪽 영역
 * 
 * 기본적으로 50% 너비를 차지하지만, flex 속성으로 조정 가능합니다.
 */
export const RightArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`;



/**
 * ResizableSplit 내부 패널 공통 래퍼
 * - height: 100%를 강제해서 내부 그리드(RealGrid)가 0 높이로 계산되는 문제를 방지합니다.
 */
export const ResizablePane = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  height: 100%;
  width: 100%;
`;

// ==================== Dev: 컨텍스트 메뉴 (Ctrl + 우클릭) ====================
export const DevContextMenuContainer = styled.div`
  position: fixed;
  z-index: 99999;
  background: ${cssVar('color-bg-white', theme.colors.white)};
  border: 1px solid ${cssVar('color-border', theme.colors.border)};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border-radius: ${theme.borderRadius.sm};
  min-width: 260px;
  padding: 6px;
  font-size: 13px;
  color: ${cssVar('color-text', theme.colors.text.primary)};
`;

export const DevContextMenuTitle = styled.div`
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 700;
  color: ${cssVar('color-text', theme.colors.text.primary)};
  user-select: text;
  white-space: nowrap;
`;

export const DevContextMenuSubText = styled.div`
  padding: 6px 10px;
  color: ${cssVar('color-text-tertiary', theme.colors.text.tertiary)};
  font-size: 12px;
  user-select: text;
  white-space: nowrap;
`;

export const DevContextMenuDivider = styled.div`
  height: 1px;
  background: ${cssVar('color-border-light', theme.colors.borderLight)};
  margin: 6px 0;
`;

export const DevContextMenuItem = styled.div`
  padding: 8px 10px;
  cursor: pointer;
  border-radius: 4px;
  user-select: none;
  white-space: nowrap;

  &:hover {
    background-color: ${cssVar('color-primary', theme.colors.primary)};
    color: var(--erp-color-on-accent, #FFFFFF);
  }
`;

// 필드 너비 상수 (SearchArea 등에서 사용)
export const CommonCss = {
  w50: '50px',
  w60: '60px',
  w70: '70px',
  w80: '80px',
  w90: '90px',
  w100: '100px',
  w110: '110px',
  w120: '120px',
  w130: '130px',
  w140: '140px',
  w150: '150px',
  w160: '160px',
  w170: '170px',
  w180: '180px',
  w190: '190px',
  w200: '200px',
  w210: '210px',
  w220: '220px',
  w230: '230px',
  w240: '240px',
  w250: '250px',
  w260: '260px',
  w270: '270px',
  w280: '280px',
  w290: '290px',
  w300: '300px',
};

// ==================== 스타일 컴포넌트 ====================
/**
 * Form 영역 컨테이너 (조회 상세 정보)
 * 
 * 여러 필드를 2열 또는 3열로 배치하는 레이아웃
 */
export const FormArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  margin-bottom: ${theme.spacing.xxs};
  padding: ${theme.spacing.sm};
  background-color: transparent;
  border-radius: ${theme.borderRadius.md};
`;

/**
 * Form 필드 행 (2열 또는 3열 배치)
 */
export const FormRow = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
  flex-wrap: wrap;
  min-height: var(--erp-control-height, 28px);
  height: auto;
`;

/** 조회조건 등 한 줄 밀집 배치 — 필드 그룹 간 간격은 라벨~입력보다 넓게 */
export const FormRowCompact = styled(FormRow)`
  gap: var(--erp-form-row-gap, ${theme.components?.form?.rowGap || '12px'});
  height: auto;
  min-height: var(--erp-control-height, 28px);
  flex-wrap: nowrap;

  @media (max-width: 1100px) {
    flex-wrap: wrap;
  }
`;

/** 상세 폼 — 간격만 줄이고 줄바꿈 허용 */
export const FormRowTight = styled(FormRow)`
  gap: var(--erp-form-row-gap, ${theme.components?.form?.rowGap || '12px'});
  height: auto;
  min-height: 30px;
`;

export const FormAreaCompact = styled(FormArea)`
  padding: ${theme.spacing.xxs} ${theme.spacing.sm};
  margin-bottom: 0;
`;

/**
 * Form 필드 아이템 (라벨 + 값)
 */
export const FormField = styled.div`
  display: flex;
  align-items: center;
  gap: var(--erp-form-field-gap, ${theme.components?.form?.fieldGap || '6px'});
  min-width: 0;
  flex: ${props => props.flex || '0 0 auto'};
  width: ${props => props.width || 'auto'};
`;

export const FormFieldLabel = styled.label`
  font-size: ${theme.typography.fontSize.sm};
  color: ${cssVar('color-text-secondary', theme.colors.text.secondary)}; /* 에러 시 빨간색 */
  font-weight: 500;
  box-sizing: border-box;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  text-align: right;
  white-space: nowrap;
  /* width·min-width 동일 → 필드명 끝~입력 시작 간격이 전 화면에서 FormField gap과 일치 */
  min-width: ${props => props.width || '70px'};
  width: ${props => props.width || '70px'};
`;

/**
 * Form 필드 값 (input 태그)
 * 
 * readonly prop을 받아서 읽기 전용 스타일을 적용합니다.
 * - readonly: true -> 배경색 회색, 포인터 변경, 편집 불가
 * - readonly: false -> 일반 input 스타일, 편집 가능
 */
export const FormFieldValue = styled.input`
  padding: ${theme.spacing.xs} ${theme.spacing.xs};
  border: 1px solid ${cssVar('color-border', theme.colors.border)};
  border-radius: var(--erp-radius-sm, ${theme.borderRadius.sm});
  font-size: ${theme.typography.fontSize.sm};
  color: ${cssVar('color-text', theme.colors.text.primary)};
  width: ${props => props.width || '300px'};
  min-height: var(--erp-control-height, 28px);
  box-sizing: border-box;
  background-color: ${props => props.readOnly ? cssVar('color-bg-light', theme.colors.background.light) : cssVar('color-bg-white', theme.colors.white)};
  cursor: ${props => props.readOnly ? 'default' : 'text'};

  &:focus {
    outline: none;
    border-color: ${props => props.readOnly ? cssVar('color-border', theme.colors.border) : cssVar('color-primary', theme.colors.primary)};
    box-shadow: ${props => props.readOnly ? 'none' : '0 0 0 2px rgba(37, 99, 235, 0.15)'};
  }

  &:disabled {
    background-color: ${cssVar('color-bg-light', theme.colors.background.light)};
    cursor: not-allowed;
  }
`;

/**
 * Form 필드 값 (textarea 태그)
 * 
 * readonly prop을 받아서 읽기 전용 스타일을 적용합니다.
 * - readonly: true -> 배경색 회색, 포인터 변경, 편집 불가
 * - readonly: false -> 일반 textarea 스타일, 편집 가능
 */
export const FormFieldTextArea = styled.textarea`
  padding: ${theme.spacing.xs} ${theme.spacing.xs};
  border: 1px solid ${cssVar('color-border', theme.colors.border)};
  border-radius: ${theme.borderRadius.sm};
  font-size: ${theme.typography.fontSize.sm};
  color: ${cssVar('color-text', theme.colors.text.primary)};
  width: ${props => props.width || '300px'};
  background-color: ${props => props.readOnly ? cssVar('color-bg-light', theme.colors.background.light) : cssVar('color-bg-white', theme.colors.white)};
  cursor: ${props => props.readOnly ? 'default' : 'text'};
  resize: vertical; /* 세로 방향으로만 크기 조절 가능 */
  font-family: inherit; /* 부모 폰트 상속 */

  &:focus {
    outline: none;
    border-color: ${props => props.readOnly ? cssVar('color-border', theme.colors.border) : cssVar('color-primary', theme.colors.primary)};
    box-shadow: ${props => props.readOnly ? 'none' : '0 0 0 2px rgba(37, 99, 235, 0.15)'};
  }

  &:disabled {
    background-color: ${cssVar('color-bg-light', theme.colors.background.light)};
    cursor: not-allowed;
  }
`;


// Radio 버튼 그룹을 위한 스타일 컴포넌트
export const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: ${theme.typography.fontSize.sm}; /* 11px */
  
  input[type="radio"] {
    cursor: pointer;
    margin: 0;
  }
  
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

// Checkbox 버튼 그룹을 위한 스타일 컴포넌트
export const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  flex-wrap: wrap;
`;

export const CheckboxOption = styled.label`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: ${theme.typography.fontSize.sm}; /* 11px */
  
  input[type="checkbox"] {
    cursor: pointer;
    margin: 0;
  }
  
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

/**
 * Form 필드 값과 버튼을 함께 감싸는 컨테이너
 * 필드 옆에 버튼을 배치할 때 사용합니다.
 */
export const FormFieldValueWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  flex: 1;
`;

/**
 * Form 필드 옆에 배치되는 버튼
 * 필드 값 영역 내부에 작은 버튼을 표시할 때 사용합니다.
 */
export const FormFieldButton = styled.button`
  padding: ${theme.spacing.xs} ${theme.spacing.xs};
  border: 1px solid ${cssVar('color-border', theme.colors.border)};
  border-radius: ${theme.borderRadius.sm};
  background-color: ${props => {
    if (props.$variant === 'primary') return cssVar('color-primary', theme.colors.primary);
    if (props.$variant === 'success') return theme.colors.status.success;
    if (props.$variant === 'danger') return theme.colors.status.error;
    return cssVar('color-bg-light', theme.colors.background.light);
  }};
  color: ${props => {
    if (props.$variant === 'primary' || props.$variant === 'success' || props.$variant === 'danger') {
      return 'var(--erp-color-on-accent, #FFFFFF)';
    }
    return cssVar('color-text', theme.colors.text.primary);
  }};
  font-size: ${theme.typography.fontSize.sm};
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0; /* 버튼이 줄어들지 않도록 */

  &:hover {
    opacity: 0.8;
    transform: translateY(-1px);
    box-shadow: ${theme.shadows.sm};
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// ==================== Common: Dialog(Modal) ====================
/**
 * 공통 다이얼로그 Overlay
 * - 팝업/다이얼로그 배경(dim)
 */
export const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

/**
 * 공통 다이얼로그 컨테이너
 * - width/height는 props로 제어
 */
export const DialogContainer = styled.div`
  width: ${props => props.$width || '860px'};
  height: ${props => props.$height || '640px'};
  background: var(--erp-color-bg-white, ${cssVar('color-bg-white', theme.colors.white)});
  border-radius: 10px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const DialogHeader = styled.div`
  padding: 14px 16px;
  border-bottom: 1px solid var(--erp-color-border, ${cssVar('color-border', theme.colors.border)});
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DialogTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: var(--erp-color-text, ${cssVar('color-text', theme.colors.text.primary)});
`;

export const DialogCloseButton = styled.button`
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: var(--erp-color-text-secondary, ${cssVar('color-text-secondary', theme.colors.text.secondary)});
  padding: 0;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;

  &:hover {
    background: var(--erp-color-bg-light, ${cssVar('color-bg-medium', theme.colors.background.medium)});
    color: var(--erp-color-text, ${cssVar('color-text', theme.colors.text.primary)});
    border-color: var(--erp-color-border, ${cssVar('color-border', theme.colors.border)});
  }

  &:active {
    background: var(--erp-color-border, ${cssVar('color-border', theme.colors.border)});
  }

  &:focus-visible {
    outline: 2px solid var(--erp-color-focus-ring, ${theme.colors.focusRing});
    outline-offset: 1px;
  }
`;

export const DialogBody = styled.div`
  padding: 12px 16px 16px 16px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DialogGridArea = styled.div`
  flex: 1;
  min-height: 0;
`;

